// extracted by mini-css-extract-plugin
export var container = "text-module--container--Me+ti";
export var date = "text-module--date--kLykY";
export var expoimg = "text-module--expoimg--9QH1S";
export var iframe = "text-module--iframe--o48Hz";
export var img = "text-module--img--ciz1F";